export const ROLE_OPERATOR = 'ROLE_POSTAL_OPERATOR';
export const ROLE_CARRIER = 'ROLE_CARRIER';
export const ROLE_ADMIN = 'ROLE_IPC_ADMIN';
export const PENDING = 'Pending';
export const DISAPPROVED = 'Disapproved';

export const MIN_ALA_LEVEL = 1;
export const MAX_ALA_LEVEL = 9;
export const ALL_ALA_LEVELS_LABEL = 'All';

export const ALA_LEVELS_OPTIONS_WITHOUT_ALL = (() => {
  const alaLevels = [];
  for (let i = MIN_ALA_LEVEL; i <= MAX_ALA_LEVEL; i += 1) {
    alaLevels[i] = { value: i, label: `ALA${i}` };
  }
  return alaLevels.filter(obj => obj);
})();

export const CURRENT_DATE = new Date();
